import React from 'react';
import { Box, Avatar, Paragraph, Text, Anchor, ResponsiveContext } from "grommet";

const titleContent = [
    'Tan Khai Ze',
    '- Full Stack Web Developer',
    '- React / React-Native Developer'
]

const PersonalInfo = () => {
    return (
        <ResponsiveContext.Consumer>
            { size => (
                <Box pad={{ horizontal: 'xlarge', vertical: 'large' }}>
                    <Box align="center" direction="row" justify={size === "small" ? 'center' : 'start'}>
                        <Avatar size={size !== "small" ? '12rem' : '15rem'} src={ require('../assets/images/me.jpg') } />
                    </Box>
                    <Box pad={{ vertical: 'medium' }}>
                        {
                            titleContent.map(content => {
                                return <Text key={content} color="primaryTextColor" weight="bold" size="xxlarge">{ content }</Text>
                            })
                        }
                    </Box>
                    <Box pad={{ vertical: 'medium' }}>
                        <Paragraph color="secondaryTextColor" size="large" alignSelf="stretch" fill style={{ lineHeight: 2.0 }}>
                            I am a Full Stack Web Developer, specialised in building Web Application Development. Building App for Android & iOS using React-Native. Passionate about Technology. Feel free to drop me an email to 
                            {
                                size !== "small" && (
                                    <Anchor margin={{ left: 'small' }} color="anchorTextColor" size="xlarge" href="mailto:khaizetan94@gmail.com">khaizetan94@gmail.com</Anchor>
                                )
                            }
                        </Paragraph>
                        {
                            size === "small" ?
                            <Anchor color="anchorTextColor" size="medium" href="mailto:khaizetan94@gmail.com">khaizetan94@gmail.com</Anchor>
                            : null
                        }
                    </Box>
                </Box>
            )}
        </ResponsiveContext.Consumer>
    )
}

export default PersonalInfo;